<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/access">アクセス</router-link></li>
          <li><router-link to="/access/bicycle">コミュニティサイクルをご利用の方</router-link></li>
        </ul>
      </div>
    </div>
    <div class="access">
      <div class="container">
        <h2 class="page--title">ACCESS<span>アクセス</span></h2>
        <AccessMenu :accessMenuChild="accessMenu" />
        <div class="tab-content">
          <div id="content--6" class="access__content content--6">
            <h2>コミュニティサイクルの設置場所</h2>
            <div class="img_holder">
              <img
                src="@/assets/img/access/access_img_6.jpg"
                alt="access chart"
              />
              <p>
                （仮）HARUMI
                FLAGでは、敷地内に約400台分のポートを設置する予定で、敷地内の移動や周辺エリアへのアクセス利便が向上します。
              </p>
            </div>
            <div class="link_holder two--btn">
              <a href="">
                <span>ご予約はこちら</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
              <a class="btn-white" href="">
                <span>ご利用方法はこちら</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_blue.svg"
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import CONSTANT from "../../../constant";
import { RouterLink } from "vue-router";

export default {
  name: "Bicycle",
  components: {
    AccessMenu: () => import("@/components/common/AccessMenu.vue"),
  },
  data() {
    return {
      accessMenu: CONSTANT.dataAccessMenu,
    };
  },

  computed: {},
};
</script>